import RestProjectController from '../../../hooks/RestProjectController'
import { useCallback, useEffect } from 'react'
import useExportData from '../../../hooks/useExportData'

const ThinContentController = (model) => {

  // Hooks
  const { rest } = RestProjectController();

  useEffect(()=> {
    handleSearchProjects(null)
  }, [])


  // Funtions

  // Applu params when any of the filter changes
  const handleFilterUpdate = (name, from, to, action) => {
    model.setFilter((prevItems) => {
      const newItems = new Map([...prevItems]);

      // Initialize an object to store filter values directly
      const payload = {};

      if (action === "delete") {
        // Remove the filter keys from the Map
        newItems.delete(`${name}From`);
        newItems.delete(`${name}To`);
        newItems.delete(`${name}`);
      } else if (name === 'intention') {
        newItems.set(`${name}`, action);
      } else {
        if (from) newItems.set(`${name}From`, from);
        if (to) newItems.set(`${name}To`, to);
      }

      // Convert the Map into an object with only raw values
      newItems.forEach((value, key:any) => {
        payload[key] = value; // Store only the value, no extra object
      });

      // Update model state (if needed)
      model.setFilter(newItems);

      return new Map(newItems); // Ensure React detects changes
    });
  };


  // perform the search
  const handleSearchProjects = useCallback(async (cleanParams: boolean) => {
    const params = { };

    model.setIsLoading((prev) => ({ ...prev, projects: true }))
    rest({ params, endpoint: 'getProjects' })
      .then((data) => {
        model.setProjectsData(data)
      })
      .catch((error) => {
        console.error(`Error:`, error);
      })
      .finally(() => {
        model.setIsLoading((prev) => ({ ...prev, projects: false }))
      })

  }, []);

  // perform the search
  const handleSearchBtn = useCallback(async (cleanParams: boolean) => {
    const params = { project: model.projectSelected };

    model.filter.forEach((value, key) => {
      params[key] = value;
    });

    model.setIsLoading((prev) => ({ ...prev, search: true }))
    model.setIsLoading((prev) => ({ ...prev, keywords: true }))
    rest({ params, endpoint: 'getThinContent' })
      .then((data) => {
        const formattedData = convertThinContentResponse(data);
        model.setKeywordsData(formattedData);
      })
      .catch((error) => {
        console.error(`Error:`, error);
      })
      .finally(() => {
        model.setIsLoading((prev) => ({ ...prev, keywords: false }))
        model.setIsLoading((prev) => ({ ...prev, search: false }))
      })

  }, [model.projectSelected, model.filter, model.sortModel, model.paginationModel, model.modeFilter]);


  const { fetchExportProjectsThinContent, isLoading: isExportLoading } = useExportData();
  // Export to excel
  const handleExportExcel = async () => {
    model.setIsLoading({ export: true })
    const params = { project: model.projectSelected, url: model.url, mode: model.modeFilter, dateFrom: model.filter.get('dateFrom'), dateTo: model.filter.get('dateTo')}
    await fetchExportProjectsThinContent({ ...params });
    model.setIsLoading({ export: false })
  }


  const convertThinContentResponse = (response) => {
    return Object.entries(response.items).map(([url, data]) => ({
      url,
      ...data
    }));
  };

  return {
    handleFilterUpdate,
    handleSearchBtn,
    handleExportExcel
  }
}

export default ThinContentController